export default function initScrollReveal(targetElements) {
  const showEverything = () => document.documentElement.classList.remove("sr");
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (!targetElements.length || reduceMotion || !("IntersectionObserver" in window)) {
    showEverything();
    return;
  }

  try {
    const nodes = [];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("reveal-visible");
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: "0px 0px -8%", threshold: 0.08 }
    );

    targetElements.forEach(({ element, animation = {} }) => {
      const interval = Number(animation.interval) || 0;

      document.querySelectorAll(element).forEach((node, index) => {
        node.classList.add("reveal-ready");
        node.style.setProperty("--reveal-delay", `${Math.min(interval * index, 240)}ms`);
        nodes.push(node);
      });
    });

    showEverything();
    nodes.forEach((node) => observer.observe(node));
  } catch (error) {
    showEverything();
  }
}
